var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowBack = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.157,
    height: 18,
    viewBox: "0 0 26.157 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.157 18) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.8,8.14,18.017.356a1.216,1.216,0,1,0-1.72,1.72L22,7.784H1.216a1.216,1.216,0,1,0,0,2.432H22L16.3,15.924a1.216,1.216,0,0,0,1.72,1.72L25.8,9.86A1.216,1.216,0,0,0,25.8,8.14Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-back.ca338104.svg";
export { ForwardRef as ReactComponent };